export default "__VITE_ASSET__JklX$bzL__"